import { useTranslation } from 'react-i18next';
import { ChapterFilled, TimeFilled , Document } from '@teo/components/icons';
import { useState, useContext, useEffect } from 'react';
import { useGet } from '@/query/fetchHooks';
import { AuthContext } from '@/components/Contexts/AuthContext';
import { Lerningpathorganisationdetails } from '@/models';
import UploadDropzoneSection from '@/components/UploadDropzoneSection/UploadDropzoneSection';
import { axios } from '@/axios';
import { config } from '@/config';
import {
  PersonAvatar,
  PageHeader,
  Button,
  Switch,
  IconButton,
  Tabs,
  Tag,
  InputText,
  Spinner,
  Dropdown,
} from '@teo/components';
import { NotificationContext } from '@/components/Contexts/NotificationContext';
import { copyToClipboard } from '@/util';

function IntegrationsPage() {
  const { t } = useTranslation();
  const { auth } = useContext(AuthContext);
  const [exportLink, setExportLink] = useState('');
  const { setShowNotification } = useContext(NotificationContext);

  useGet<any>(`/lti/link/${auth?.user?.activeOrganisationId}`, {
    onSuccess: (result: any) => {
      setExportLink(result?.data?.url || '');
    },
  });

  return (
    <div className="w-full">
      <div className="flex items-center justify-between">
        <h1 className="my-6 text-xl font-semibold text-black">
          {t('pages.integrations.title')}
        </h1>
      </div>
      <div className="flex flex-col">
        <div className="rounded-lg border border-grey-02 p-6">
          <h2 className="my-6 text-xl font-semibold text-black">LTI</h2>
          <p className="mb-4">{t('pages.integrations.lti_text')}</p>
          <div className="flex">
            <InputText
              className="flex-grow"
              value={exportLink}
              onChange={(ev) => {}}
            />
            <IconButton
              Icon={Document}
              variant="ghost"
              className="mx-2 text-[#231f20]"
              onClick={() => {
                copyToClipboard(exportLink);
                setShowNotification({
                  message: t('message.link_copied'),
                  delay: 1000,
                });
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default IntegrationsPage;
